module.exports = __webpack_public_path__ + "img/workContents01_pc_06.127df512.png";